import React from 'react';

import printerImage from './img/printer-color.svg';

const recentBookingTuple = (props) => {
    return (
        <div className={`u-backgroundColorWhite u-transitionBgColor300Ease u-borderRadius4 u-boxShadowThin pt-5 pb-5 pl-5 pr-7 u-flex phone-justify-content-between u-fontSize13 phone-pl-2 phone-pr-2 phone-pt-2 phone-pb-2 phone-f-column`}>
            <div className="u-flex phone-mb-1">
                <span className="u-phoneShow mr-auto u-lineHeight1">YT Number:</span>
                <span className={`u-textColorDark u-phone-lineHeight1`}>{props.data.bkid}</span>
            </div>
            <div className={`u-width120 u-phone-widthAuto u-flex phone-mb-1 ml-8Pt5Per phone-ml-0`}>
                <span className="u-phoneShow mr-auto u-lineHeight1">Passenger Name:</span>
                <span className={`u-textColorLight u-phone-lineHeight1`}>{props.data.lpax}</span>
            </div>
            <div className={`u-width120 u-phone-widthAuto u-flex phone-mb-1 ml-8Pt5Per phone-ml-0`}>
                <span className="u-phoneShow mr-auto u-lineHeight1">Sector:</span>
                <span className={`u-textColorLight u-phone-lineHeight1`}>{props.data.org} - {props.data.dest}</span>
            </div>
            <div className={`u-width120 u-phone-widthAuto u-flex phone-mb-1 ml-8Pt5Per phone-ml-0`}>
                <span className="u-phoneShow mr-auto u-lineHeight1">Date:</span>
                <span className={`u-textColorLight u-phone-lineHeight1`}>{props.data.atd}</span>
            </div>
            <div className="u-flex phone-mb-1 ml-auto phone-ml-0">
                <span className="u-phoneShow mr-auto u-lineHeight1">Action(s):</span>
                <span className={`u-textColorLight u-cursorPointer u-phone-lineHeight1`} onClick={() => {window.open(props.data.bkd_url, "_blank");}}>
                    <span className="u-phoneShow u-textColorPrimary">Print</span>
                    <img src={printerImage} alt='Printer' className={`u-width20 u-phoneHide`}/>
                </span>
            </div>
        </div>
    );
}

export default recentBookingTuple;


// WEBPACK FOOTER //
// ./src/components/RecentBooking/RecentBookingTuple/RecentBookingTuple.js